/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Uracil (U) is counted as thymine (T), so RNA sequences give the expected GC content.`)
};

const es_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El uracilo (U) se cuenta como timina (T), así que las secuencias de ARN dan el contenido GC esperado.`)
};

const de_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Uracil (U) wird als Thymin (T) gezählt, sodass RNA-Sequenzen den erwarteten GC-Gehalt ergeben.`)
};

const nl_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Uracil (U) wordt geteld als thymine (T), zodat RNA-sequenties het verwachte GC-gehalte geven.`)
};

const fr_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. L'uracile (U) est compté comme la thymine (T), donc les séquences d'ARN donnent le contenu GC attendu.`)
};

const it_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. L'uracile (U) viene contato come timina (T), quindi le sequenze di RNA danno il contenuto GC atteso.`)
};

const pt_br2_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A uracila (U) é contada como timina (T), então sequências de RNA fornecem o conteúdo GC esperado.`)
};

const pt_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O uracilo (U) é contado como timina (T), pelo que as sequências de ARN dão o conteúdo GC esperado.`)
};

const ja_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ウラシル (U) はチミン (T) としてカウントされるため、RNA配列でも期待どおりのGC含量が得られます。`)
};

const zh_gc_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用。尿嘧啶（U）会按胸腺嘧啶（T）计数，因此 RNA 序列也能得到正确的 GC 含量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_a3", locale)
	if (locale === "en") return en_gc_faq_a3(inputs)
	if (locale === "es") return es_gc_faq_a3(inputs)
	if (locale === "de") return de_gc_faq_a3(inputs)
	if (locale === "nl") return nl_gc_faq_a3(inputs)
	if (locale === "fr") return fr_gc_faq_a3(inputs)
	if (locale === "it") return it_gc_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_a3(inputs)
	if (locale === "pt") return pt_gc_faq_a3(inputs)
	if (locale === "ja") return ja_gc_faq_a3(inputs)
	return zh_gc_faq_a3(inputs)
};